import {
  CREATE_GROUP_API,
  DETELE_GROUP_API,
  EXPORT_SERIAL_NUMBER_API,
  EXPORT_MISSING_LICENSE_KEYS_API,
  GET_SIMPLEGROUPS_API,
  GET_GROUP_CONFIGURATION_COLUMNS_API,
  GET_GROUP_CREATION_INFO_API,
  GET_GROUP_DETAIL_API,
  GET_GROUP_IS_GENERATING_API,
  GET_OTAP_SUMMARY_API,
  SEARCH_GROUP_API,
  UPDATE_GROUP_API
} from '~/constants/APIs'
import {
  GroupCreationInfoType,
  GroupDetailType,
  GroupGeneratingType,
  GroupSearchRequests,
  GroupSearchResults,
  IGroupConfigurationColumn,
  IGroupDropdownData,
  IOtapSummary
} from '~/models'
import { EditGroupFormType } from '~/pages/Groups/components/GroupDetail'
import { NewGroupFormType } from '~/pages/Groups/components/Popups/NewGroupPopup'
import axiosClient from './axiosClient'

export const groupApis = {
  search: (params: GroupSearchRequests) =>
    axiosClient.get(SEARCH_GROUP_API, { params }) as unknown as GroupSearchResults,

  getGroupDetail: (groupId: number | null) =>
    axiosClient.get(GET_GROUP_DETAIL_API + groupId) as unknown as GroupDetailType,

  getGroupIsGenerating: (groupId: number | null) =>
    axiosClient.get(GET_GROUP_IS_GENERATING_API, {
      params: { groupId }
    }) as unknown as GroupGeneratingType,

  getGroupCreationInfo: (onlyCustomizationProfile: boolean) =>
    axiosClient.get(GET_GROUP_CREATION_INFO_API, {
      params: { onlyCustomizationProfile }
    }) as unknown as GroupCreationInfoType,

  getGroupConfigurationColumns: (groupId: number | null) =>
    axiosClient.get(GET_GROUP_CONFIGURATION_COLUMNS_API, {
      params: { groupId }
    }) as unknown as IGroupConfigurationColumn[],

  createGroup: (data: NewGroupFormType) => axiosClient.post(CREATE_GROUP_API, data),

  updateGroup: (data: EditGroupFormType) =>
    axiosClient.put(UPDATE_GROUP_API + data.groupId, data),

  deleteGroup: (data: any) => axiosClient.delete(DETELE_GROUP_API, { data }),

  exportSerialNumber: (groupId: number | null) =>
    axiosClient.get(EXPORT_SERIAL_NUMBER_API, {
      params: { groupId },
      responseType: 'blob'
    }),
  exportMisingLicenseKeys: (groupId: number | null) =>
      axiosClient.get(EXPORT_MISSING_LICENSE_KEYS_API, {
        params: { groupId },
        responseType: 'blob'
      }),
  getOtapSummary: (groupId?: number | null) =>
    axiosClient.get(GET_OTAP_SUMMARY_API, {
      params: { groupId }
    }) as unknown as IOtapSummary,

  getSimpleGroups: (deviceFormationTypeId: number) => {
    const formationTypeId = deviceFormationTypeId > 0 ? deviceFormationTypeId : undefined
    return axiosClient.get(GET_SIMPLEGROUPS_API, {
      params: { formationTypeId }
    }) as unknown as IGroupDropdownData[]
  }
}
